module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"carbonEmissionTitle":"Toplam Karbon Emisyonları","emissionType":"Emisyon Kaynakları","carbonEmissionChanging":"Değişim (%)","emissionError":"Emisyon verisi bulunamadı"},"en":{"carbonEmissionTitle":"Total Carbon Emissions","emissionType":"Sources of Emission","carbonEmissionChanging":"Change (%)","emissionError":"No emissions data"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/carbonEmissionTable.json
// module id = 7q7y
// module chunks = 1